/* eslint-disable react/prop-types */
import { Box, Paper, TextField, Button } from "@mui/material";
import MuiPagination from "@mui/material/Pagination";
import { styled } from "@mui/material/styles";
import React, { useState } from "react";
import ArrowIcon from "../../../../assets/svg/Arrow";
import { Constants } from "../../../../contants";
import { styles } from "./Pagination.styles";

const PRIMARY_COLOR = "#183053";

const PaginationWrapper = styled(MuiPagination)({
  "& .MuiPaginationItem-text": {
    color: PRIMARY_COLOR,
    fontWeight: 500,
    fontSize: 14,
  },
  "& .Mui-selected": {
    color: "#fff",
    backgroundColor: `${PRIMARY_COLOR} !important`,
  },
});

function Pagination({
  totalPages,
  currentPage,
  totalResults,
  pageSize,
  onChange,
  onPageSizeClick,
}) {
  const [goToPage, setGoToPage] = useState("");

  const handleGoToPage = () => {
    const pageNumber = Number(goToPage);

    if (!pageNumber || pageNumber < 1 || pageNumber > totalPages) {
      return;
    }

    onChange(pageNumber - 1);
    setGoToPage("");
  };

  return (
    <Paper
      elevation={3}
      style={{
        ...styles.container,
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "12px 16px",
        flexWrap: "wrap",
      }}
    >
      <PaginationWrapper
        count={totalPages}
        size="large"
        shape="rounded"
        page={currentPage + 1}
        onChange={(_e, number) => onChange(number - 1)}
      />

      <Box
        style={{
          ...styles.right,
          display: "flex",
          alignItems: "center",
          gap: "12px",
          flexWrap: "wrap",
        }}
      >
        <span style={styles.text}>Show:</span>

        <Box style={styles.pageSize}>
          <span style={styles.text}>{pageSize} Rows</span>
          <Box style={styles.arrow}>
            <ArrowIcon
              style={{
                ...styles.upArrowIcon,
                ...(pageSize >= Constants.MAX_PAGE_SIZE ||
                pageSize * (currentPage + 1) >= totalResults
                  ? styles.disabled
                  : {}),
              }}
              onClick={() => onPageSizeClick("plus")}
            />
            <ArrowIcon
              style={{
                ...styles.downArrowIcon,
                ...(pageSize <= Constants.MIN_PAGE_SIZE ? styles.disabled : {}),
              }}
              onClick={() => onPageSizeClick("subtract")}
            />
          </Box>
        </Box>

        <Box
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span style={styles.text}>Go to Page:</span>
          <TextField
            size="small"
            type="number"
            value={goToPage}
            onChange={(e) => setGoToPage(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleGoToPage();
              }
            }}
            inputProps={{
              min: 1,
              max: totalPages,
            }}
            sx={{
              width: "75px",
              "& .MuiInputBase-input": {
                padding: "6px 8px",
              },
            }}
          />
          <Button
            variant="contained"
            size="small"
            onClick={handleGoToPage}
            sx={{
              textTransform: "none",
              minWidth: "fit-content",
              backgroundColor: PRIMARY_COLOR,
              padding: "6px 10px",
            }}
          >
            Go
          </Button>
        </Box>
      </Box>
    </Paper>
  );
}

export default Pagination;
